// extracted by mini-css-extract-plugin
module.exports = {"inputWhereFrameMap":"theme_inputWhereFrameMap__2k_0p"};